import toast from 'react-hot-toast';

interface ToastProps {
  title: string;
  description: string;
  status: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
  isClosable?: boolean;
  position?: 'top-right' | 'top' | 'bottom-right' | 'bottom' | 'top-left' | 'bottom-left';
}

const showToast = ({
  title,
  description,
  status,
  duration = 3000,
}: ToastProps) => {
  const message = (
    <div className="flex flex-col gap-1">
      <h3 className="font-bold">{title}</h3>
      <p className="text-sm opacity-90">{description}</p>
    </div>
  );

  switch (status) {
    case 'success':
      toast.success(message, { duration });
      break;
    case 'error':
      toast.error(message, { duration });
      break;
    default:
      toast(message, { duration });
  }
};

export default showToast;
